import type { Post } from "src/types/blog";
import { deepCopy } from "src/utils/deep-copy";
import { postPosts, posts } from "./data";

type GetPostsRequest = {};

type GetPostsResponse = Promise<Post[]>;

type GetPostRequest = string;

type GetPostResponse = Promise<Post>;

// Helper function to normalize a title to a slug
const normalizeSlug = (text: string): string => {
  return text.replace(/\s+/g, "-");
};

class BlogApi {
  getPosts(request?: GetPostsRequest): GetPostsResponse {
    return Promise.resolve(deepCopy(posts));
  }

  getPost(request?: GetPostRequest): GetPostResponse {
    if (!request) {
      return Promise.reject(new Error("Post title is required"));
    }

    // Try to decode the request in case it's URL encoded
    let decodedRequest = request;
    try {
      decodedRequest = decodeURIComponent(request);
    } catch (e) {
      // If decoding fails, use the original request
      decodedRequest = request;
    }
    
    // Normalize the request slug
    const normalizedRequest = normalizeSlug(decodedRequest);
    
    const matchesSlug = (value: string) =>
      normalizeSlug(value).toLowerCase() === normalizedRequest.toLowerCase();

    const post = postPosts.find((post) => {
      if (matchesSlug(post.title)) {
        return true;
      }
      return (post.aliases ?? []).some(matchesSlug);
    });

    if (!post) {
      return Promise.reject(new Error("Post not found"));
    }

    return Promise.resolve(deepCopy(post));
  }
}

export const blogApi = new BlogApi();
